export const monitoringConstants = {
  SET_MONITORING_LOADING: 'monitoring/SET_MONITORING_LOADING',
  GET_MONITORING: 'monitoring/GET_MONITORING',
  SET_MONITORING: 'monitoring/SET_MONITORING',
  CLEAR_MONITORING: 'monitoring/CLEAR_MONITORING',
  GET_AVAILABILITY_DEVICES: 'monitoring/GET_AVAILABILITY_DEVICES',
  SET_AVAILABILITY_DEVICES: 'monitoring/SET_AVAILABILITY_DEVICES',
  CLEAR_AVAILABILITY_DEVICES: 'monitoring/CLEAR_AVAILABILITY_DEVICES',
  GET_AVAILABILITY_DEVICES_BY_PERIOD:
    'monitoring/GET_AVAILABILITY_DEVICES_BY_PERIOD',
  SET_AVAILABILITY_DEVICES_BY_PERIOD:
    'monitoring/SET_AVAILABILITY_DEVICES_BY_PERIOD',
  CLEAR_AVAILABILITY_DEVICES_BY_PERIOD:
    'monitoring/CLEAR_AVAILABILITY_DEVICES_BY_PERIOD',
  SET_APPLICATIONS_LOADING: 'monitoring/SET_APPLICATIONS_LOADING',
  GET_APPLICATIONS: 'monitoring/GET_APPLICATIONS',
  SET_APPLICATIONS: 'monitoring/SET_APPLICATIONS',
  CLEAR_APPLICATIONS: 'monitoring/CLEAR_APPLICATIONS',
  SET_DEVICES_LOADING: 'monitoring/SET_DEVICES_LOADING',
  GET_DEVICES: 'monitoring/GET_DEVICES',
  SET_DEVICES: 'monitoring/SET_DEVICES',
  CLEAR_DEVICES: 'monitoring/CLEAR_DEVICES',
  SET_LOGS_LOADING: 'monitoring/SET_LOGS_LOADING',
  GET_LOGS: 'monitoring/GET_LOGS',
  SET_LOGS: 'monitoring/SET_LOGS',
  CLEAR_LOGS: 'monitoring/CLEAR_LOGS',
  SET_SCHEDULED_ACTION_LOGS_LOADING:
    'monitoring/SET_SCHEDULED_ACTION_LOGS_LOADING',
  GET_SCHEDULED_ACTION_LOGS: 'monitoring/GET_SCHEDULED_ACTION_LOGS',
  SET_SCHEDULED_ACTION_LOGS: 'monitoring/SET_SCHEDULED_ACTION_LOGS',
  CLEAR_SCHEDULED_ACTION_LOGS: 'monitoring/CLEAR_SCHEDULED_ACTION_LOGS',
  EXPORT_LOGS_ASYNC: 'monitoring/EXPORT_LOGS_ASYNC',
  SET_LOGS_EXPORT_IDENTIFIER: 'monitoring/SET_LOGS_EXPORT_IDENTIFIER',
  GET_DEVICE_ANALYTICS: 'monitoring/GET_DEVICE_ANALYTICS',
  SET_DEVICE_ANALYTICS: 'monitoring/SET_DEVICE_ANALYTICS',
  CLEAR_DEVICE_ANALYTICS: 'monitoring/CLEAR_DEVICE_ANALYTICS',
};
